import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Products from './components/Products';
import Clients from './components/Clients';
import Differentiators from './components/Differentiators';
import CTA from './components/CTA';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <a href="#main-content" className="skip-link">
        Saltar al contenido principal
      </a>
      <Header />
      <main id="main-content">
        <Hero />
        <About />
        <Services />
        <Products />
        <Clients />
        <Differentiators />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;

